import { makeObservable, observable, action } from 'mobx';

import CMDBApi from '../api/CMDBApi';

class ProjectStore {
  enabledProjects = [];
  enabledProjectsLoaded = false;

  constructor() {
    makeObservable(this, {
      enabledProjects: observable,
      enabledProjectsLoaded: observable,
      getEnabledProjects: action,
    });
  }

  async getEnabledProjects() {
    if (!this.enabledProjectsLoaded) {
      const { data } = await CMDBApi.getEnabledProjects();

      this.enabledProjects = data;
      this.enabledProjectsLoaded = true;
    }
  }
}

export default new ProjectStore();
